import clsx from 'clsx'

import { isDevelopment } from '@/utils/isDevelopment'

import { Warning } from '@/components/Warning'

import { useEntry } from '../CaseStudy.hooks'

type Props = {
	className?: string
	textColor?: string
}

export function CaseStudyStats({ className, textColor }: Props) {
	const entry = useEntry()

	if ('error' in entry) {
		if (isDevelopment()) {
			return <Warning>{entry.error}</Warning>
		}

		return null
	}

	const items = entry?.data?.caseStudyStatsCollection?.items

	if (!items || items.length === 0) {
		if (isDevelopment()) {
			return <Warning>Case study stats collection is empty</Warning>
		}

		return null
	}

	return (
		<div className={clsx('grid sm:grid-cols-2 lg:grid-cols-3 gap-y-15 gap-x-8', className)}>
			{items.map((stat, i) => {
				if (!stat?.key || !stat?.value) return null

				return (
					<div className="space-y-2.5" key={i}>
						<h2
							className="text-[92px] font-bold font-gotham-condensed"
							style={{ color: textColor }}
						>
							{stat.key}
						</h2>

						<p className="" style={{ color: textColor }}>
							{stat.value}
						</p>
					</div>
				)
			})}
		</div>
	)
}
